(() => {
  const preloadAfpModals = () => {
    if (typeof theme === 'undefined' || typeof theme.preloadProductModal !== 'function') return;
    document.querySelectorAll('.afp-card[data-product-id][data-product-handle]').forEach((card) => {
      theme.preloadProductModal(card.dataset.productHandle, card.dataset.productId, null);
    });
  };

  const initAfpCards = () => {
    preloadAfpModals();
    document.querySelectorAll('[data-afp-swatches]').forEach((swatchGroup) => {
      const card = swatchGroup.closest('.afp-card');
      if (!card) return;
      const img = card.querySelector('[data-afp-product-image]');
      const price = card.querySelector('[data-afp-price]');
      const comparePrice = card.querySelector('[data-afp-compare-price]');

      swatchGroup.querySelectorAll('[data-afp-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          const { variantImage, price: variantPrice, comparePrice: variantComparePrice } = e.currentTarget.dataset;
          if (variantImage && img) {
            img.src = variantImage;
          }
          if (variantPrice && price) {
            price.textContent = variantPrice;
          }
          if (comparePrice) {
            comparePrice.textContent = variantComparePrice || '';
            comparePrice.hidden = !variantComparePrice;
          }
          swatchGroup.querySelectorAll('[data-afp-swatch]').forEach((s) => {
            s.classList.remove('active');
          });
          e.currentTarget.classList.add('active');
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAfpCards);
  } else {
    initAfpCards();
  }
})();
